/**
 * @format
 * @module lib/marketing/import-and-display-containers
 */

const renderContainers = meta =>
  import("lib/marketing/containers-recommender" /* webpackChunkName: "marketing-containers" */)
    .then(mc => {
      mc.fetchContainer(meta.containerName).then(html => {
        mc.displayRecommendedContainer(html, meta);
      });
    })
    .catch(console.error);

export default renderContainers;
